import { render, staticRenderFns } from "./ResultSingle.vue?vue&type=template&id=63314dfc&scoped=true&"
import script from "./ResultSingle.vue?vue&type=script&lang=js&"
export * from "./ResultSingle.vue?vue&type=script&lang=js&"
import style0 from "./ResultSingle.vue?vue&type=style&index=0&id=63314dfc&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "63314dfc",
  null
  
)

export default component.exports